module.exports = __webpack_public_path__ + "school/img/readCourseBg.8a49b70f.jpg";